export {
  TRANSACTION_PIN_ACTION_CODES as DISBURSEMENT_ACTION_CODES,
  PIN_ERROR_CODES as DISBURSEMENT_PIN_ERROR_CODES,
  TRANSACTION_NOT_FOUND_MESSAGE,
} from "../../../services/utils/pinAuthUtils";

export const OTP_INACTIVITY_TIMEOUT_MS = 90000;
export const POLL_INTERVAL_MS = 3000;
export const POLL_TIMEOUT_MS = 45000;
export const TERMINAL_DISBURSEMENT_STATUSES = new Set([
  "SUCCESS",
  "FAILED",
  "REVERSED",
]);

export const PAYOUT_ACCOUNT_TYPES = {
  MOBILE_MONEY: "MOBILE_MONEY",
  BANK: "BANK",
  WALLET: "WALLET",
};

export const WITHDRAWAL_FLOW_STEPS = [
  { label: "Account & Amount", description: "Select destination" },
  { label: "Review & Confirm", description: "Verify details" },
  { label: "Authorize", description: "Confirm withdrawal" },
];

export const WITHDRAWAL_TYPE_LABEL = {
  [PAYOUT_ACCOUNT_TYPES.MOBILE_MONEY]: "Mobile Money",
  [PAYOUT_ACCOUNT_TYPES.BANK]: "Bank",
  [PAYOUT_ACCOUNT_TYPES.WALLET]: "Paykit",
};

export const WITHDRAWAL_TYPE_HEADER = {
  [PAYOUT_ACCOUNT_TYPES.MOBILE_MONEY]: {
    title: "Mobile Money Withdrawal",
    description: "Withdraw funds to your mobile money account",
  },
  [PAYOUT_ACCOUNT_TYPES.BANK]: {
    title: "Bank Transfer",
    description: "Withdraw funds directly to your linked bank account",
  },
  [PAYOUT_ACCOUNT_TYPES.WALLET]: {
    title: "Paykit Wallet Withdrawal",
    description: "Withdraw funds to another Paykit wallet",
  },
};

export const DISBURSEMENT_ACTION_TYPES = {
  CONFIRM_WITH_PIN: "CONFIRM_WITH_PIN",
};

export const DISBURSEMENT_STATUS = {
  PENDING: "PENDING",
  PROCESSING: "PROCESSING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
  REVERSED: "REVERSED",
};
